/**
 * Copyright (c) 2024 The xterm.js authors. All rights reserved.
 * @license MIT
 */

export const enum ViewportConstants {
  DEFAULT_SCROLL_BAR_WIDTH = 14
}
